import {ButtonTheme} from 'common/components/button/constants';

// Todo: Research how we can replace this.
// It is a confusing extension of button themes
export enum QueryBlockThemeExtras {
  Builder = `builder`,
}
export const QueryBlockTheme = {
  ...QueryBlockThemeExtras,
  ...ButtonTheme,
};
export type QueryBlockTheme = QueryBlockThemeExtras | ButtonTheme;

export const TRACKING_EVENTS = {
  HOVER_CONTEXT_PANEL: `[Context Panel] Hover`,
  EDIT_DESCRIPTION: `[Context Panel] Edit Description`,
  SAMPLE_EVENT: `[Context Panel] Viewed Sample Event`,
  BETA_MENU_TOGGLE_ON: `[beta menu] Toggle Beta On`,
  BETA_MENU_TOGGLE_OFF: `[beta menu] Toggle Beta Off`,
  BETA_MENU_START_SESSION: `[beta menu] Started Browser Session`,
  LEXICON_TAG_SELECTED: `[Lexicon] Select Report Events Tag`,
  LEXICON_SHOW_HIDDEN: `[Lexicon] Show Hidden Entities`,
  OPEN_EVENTS_DROPDOWN: `[mp-query-builder] Opened Events Dropdown`,
  CHANGED_FILTER: `[mp-query-builder] Changed menu filter`,
  CHANGED_SORTING: `[mp-query-builder] Changed menu sorting`,
  SEARCH_STARTED: `[mp-query-builder] Search started`,
  SEARCH_CLEARED: `[mp-query-builder] Search cleared`,
  REFRESHED_EVENTS: `[mp-query-builder] Events menu refreshed`,
  REFRESHED_PROPERTIES: `[mp-query-builder] Properties menu refreshed`,
};

export enum SelectorType {
  Text = `text`,
  Button = `button`,
}

export enum ModalType {
  CustomEvent = `CustomEvent`,
  Sharing = `ShareModal`,
}

export enum MetricType {
  People = `people`,
  Cohort = `cohort`,
  Event = `event`,
  CustomEvent = `custom-event`,
  Funnel = `funnel`,
  Retention = `retention`,
  RetentionFrequency = `retention-frequency`,
  Formula = `formula`,
}

export const MAX_LABEL_LENGTH = 115;

export const NUM_RECENT_ITEMS = 5;
